/*
 * Spec facets for the Typesense pages (nardocar_dk v5, specs.* metafields).
 * Shared by typesense-search.js (search page) and typesense-search-brands-v9.js
 * (collections). Containers and labels come from snippets/nc-typesense-spec-facets.liquid;
 * a facet whose container is missing is skipped, and an empty facet hides via CSS.
 *
 * Absent means unknown on every spec field, so all of these narrow to products
 * that carry the value. drivetrain is a facet only, never a base filter.
 */
(function () {
  "use strict";

  // refinementList facets. Booleans and numbers go to the adapter unquoted.
  var LISTS = [
    "exhaust_system",
    "pipe_diameter_mm",
    "pipe_diameter_inch",
    "race_only",
    "valvesonic",
    "tuv_certified",
    "ec_approved",
    "axle_position",
    "drivetrain",
    "min_wheel_size_inch",
  ];
  // Plain min/max range on one numeric field.
  var RANGES = { hp_stock: "hp", nm_stock: "Nm" };
  // "Fits my value": each product stores a min and a max (open ends are 0 / 9999),
  // so one value W matches when min <= W && max >= W.
  var FITS = {
    axle_load_front: { min: "axle_load_front_min_kg", max: "axle_load_front_max_kg", unit: "kg" },
    axle_load_rear: { min: "axle_load_rear_min_kg", max: "axle_load_rear_max_kg", unit: "kg" },
    drop_front: { min: "drop_front_min_mm", max: "drop_front_max_mm", unit: "mm" },
    drop_rear: { min: "drop_rear_min_mm", max: "drop_rear_max_mm", unit: "mm" },
  };
  // Spec groups (containers .ts-spec-group[data-spec-group] in the snippet). A group shows only when
  // the results are dominated by one of its categories, or the shopper picked that category, or one
  // of its own filters is active — so a mixed page (a car-model collection, a broad search) stays clean.
  var GROUPS = {
    exhaust: { categories: ["Tuning"], attributes: ["exhaust_system", "pipe_diameter_mm", "pipe_diameter_inch", "race_only", "valvesonic", "ec_approved"] },
    suspension: { categories: ["Undervogn"], attributes: ["drop_front_min_mm", "drop_front_max_mm", "drop_rear_min_mm", "drop_rear_max_mm", "axle_load_front_min_kg", "axle_load_front_max_kg", "axle_load_rear_min_kg", "axle_load_rear_max_kg", "axle_position", "drivetrain"] },
    approval: { categories: ["Undervogn", "Tuning", "Bremser"], attributes: ["tuv_certified"] },
    tuning: { categories: ["Tuning"], attributes: ["hp_stock", "nm_stock"] },
    brakes: { categories: ["Bremser"], attributes: ["min_wheel_size_inch"] },
  };
  var DOMINANT_SHARE = 0.8;

  var NUMERIC_LISTS = { pipe_diameter_mm: " mm", pipe_diameter_inch: '"', min_wheel_size_inch: '"' };
  // Always written by the indexer, so false also means "unknown": offer only "Ja".
  var TRUE_ONLY = { tuv_certified: true, ec_approved: true };

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  window.ncSpecFacets = function (ctx) {
    var instantsearch = ctx.instantsearch;
    var w = instantsearch.widgets;
    var connectRange = instantsearch.connectors.connectRange;
    var L = window.ncSpecFacetLabels || {};
    var titles = L.titles || {};
    var values = L.values || {};
    var dec = new Intl.NumberFormat(ctx.locale || "da-DK", { maximumFractionDigits: 3 }); // 3: tommer som 2.125 og 2.13 må ikke se ens ud
    var fitAttributes = [];
    Object.keys(FITS).forEach(function (k) { fitAttributes.push(FITS[k].min, FITS[k].max); });

    function container(name) {
      return document.getElementById("ts-spec-" + name);
    }

    function valueLabel(attribute, value) {
      var v = String(value);
      if (v === "true") return L.yes || v;
      if (v === "false") return L.no || v;
      if (NUMERIC_LISTS[attribute] && !isNaN(parseFloat(v))) return dec.format(parseFloat(v)) + NUMERIC_LISTS[attribute];
      var map = values[attribute];
      return (map && map[v]) || v;
    }

    function numericSort(a, b) {
      return parseFloat(a.name) - parseFloat(b.name);
    }

    function listWidget(attribute, cssClasses, templates) {
      return w.refinementList({
        container: container(attribute),
        attribute: attribute,
        sortBy: NUMERIC_LISTS[attribute] ? numericSort : ["count:desc", "name:asc"],
        limit: 8,
        showMore: true,
        showMoreLimit: 50,
        cssClasses: cssClasses,
        templates: templates,
        transformItems: function (items) {
          return items
            .filter(function (item) { return !TRUE_ONLY[attribute] || item.value === "true"; })
            .map(function (item) {
              return Object.assign({}, item, { label: valueLabel(attribute, item.value) });
            });
        },
      });
    }

    // Number fields use the price slider's input classes so they share its styling.
    function field(cls, aria, unit, placeholder) {
      return (
        '<div class="nc-elite-price-field"><input type="number" inputmode="numeric" class="' + cls + '" aria-label="' +
        esc(aria) + '" placeholder="' + esc(placeholder) + '"><span class="nc-elite-currency">' + esc(unit) + "</span></div>"
      );
    }

    function toNumber(input) {
      var n = parseFloat(String(input.value).replace(",", "."));
      return isNaN(n) ? undefined : n;
    }

    function setIfIdle(input, n) {
      if (document.activeElement === input) return;
      input.value = n === -Infinity || n === Infinity || n == null ? "" : n;
    }

    function rangeWidget(attribute, unit) {
      var el = container(attribute);
      var refs = null;
      var refine = function () {};
      return connectRange(function (opts) {
        refine = opts.refine;
        // No values in this result set: Typesense returns empty stats, which the adapter
        // turns into a 0–0 range. Real hp/Nm values are never 0.
        if (!opts.range.max) {
          el.innerHTML = "";
          refs = null;
          return;
        }
        if (!refs) {
          el.innerHTML =
            '<div class="nc-elite-price-inputs nc-spec-range">' +
              field("nc-spec-range__min", (titles[attribute] || attribute) + " " + (L.from || ""), unit, opts.range.min) +
              '<span class="nc-elite-separator">–</span>' +
              field("nc-spec-range__max", (titles[attribute] || attribute) + " " + (L.to || ""), unit, opts.range.max) +
            "</div>";
          refs = { min: el.querySelector(".nc-spec-range__min"), max: el.querySelector(".nc-spec-range__max") };
          var apply = function () { refine([toNumber(refs.min), toNumber(refs.max)]); };
          refs.min.addEventListener("change", apply);
          refs.max.addEventListener("change", apply);
        }
        refs.min.placeholder = opts.range.min;
        refs.max.placeholder = opts.range.max;
        setIfIdle(refs.min, opts.start[0]);
        setIfIdle(refs.max, opts.start[1]);
      })({ attribute: attribute });
    }

    // Two virtual connectRange widgets (min field, max field) driven by one input.
    function fitWidgets(name, fit) {
      var el = container(name);
      var input = null;
      var state = { minRefine: null, maxRefine: null, value: undefined, present: false };
      function draw() {
        if (!state.present) {
          el.innerHTML = "";
          input = null;
          return;
        }
        if (!input) {
          el.innerHTML =
            '<div class="nc-elite-price-inputs nc-spec-range">' +
              field("nc-spec-fit", titles[name] || name, fit.unit, (L.hints || {})[name] || "") +
            "</div>";
          input = el.querySelector(".nc-spec-fit");
          input.addEventListener("change", function () {
            var n = toNumber(input);
            // Typesense needs both clauses; an empty field clears both.
            state.minRefine([undefined, n]);
            state.maxRefine([n, undefined]);
          });
        }
        setIfIdle(input, state.value);
      }
      return [
        connectRange(function (opts) {
          state.minRefine = opts.refine;
        })({ attribute: fit.min }),
        connectRange(function (opts) {
          state.maxRefine = opts.refine;
          state.present = !!opts.range.max; // 0 = empty stats, see rangeWidget
          state.value = opts.start[0];
          draw();
        })({ attribute: fit.max }),
      ];
    }

    // Built on demand: the caller's facet classes/templates are defined after routing.
    function buildWidgets(cssClasses, templates) {
      var widgets = [];
      LISTS.forEach(function (a) {
        if (container(a)) widgets.push(listWidget(a, cssClasses, templates));
      });
      Object.keys(RANGES).forEach(function (a) {
        if (container(a)) widgets.push(rangeWidget(a, a.indexOf("hp_") === 0 ? L.unitHp || RANGES[a] : RANGES[a]));
      });
      Object.keys(FITS).forEach(function (name) {
        if (container(name)) widgets = widgets.concat(fitWidgets(name, FITS[name]));
      });
      return widgets;
    }

    var rangeAttributes = Object.keys(RANGES).concat(fitAttributes);

    // The category that makes up at least DOMINANT_SHARE of the results (or the one chosen), else null.
    function dominantCategory(results, state) {
      var chosen = (state.disjunctiveFacetsRefinements && state.disjunctiveFacetsRefinements.category) || [];
      if (chosen.length === 1) return chosen[0];
      var values = (results && results.getFacetValues && results.getFacetValues("category")) || [];
      var total = 0;
      var top = null;
      values.forEach(function (v) {
        total += v.count;
        if (!top || v.count > top.count) top = v;
      });
      return top && total && top.count / total >= DOMINANT_SHARE ? top.name : null;
    }

    function hasRefinement(state, attribute) {
      var list = (state.disjunctiveFacetsRefinements && state.disjunctiveFacetsRefinements[attribute]) || [];
      var numeric = (state.numericRefinements && state.numericRefinements[attribute]) || {};
      return list.length > 0 || Object.keys(numeric).some(function (op) { return (numeric[op] || []).length > 0; });
    }

    function updateGroups(search) {
      var index = search.mainIndex;
      var results = index && index.getResults();
      var state = index && index.getHelper() && index.getHelper().state;
      if (!state) return;
      var category = dominantCategory(results, state);
      Object.keys(GROUPS).forEach(function (name) {
        var el = document.querySelector('.ts-spec-group[data-spec-group="' + name + '"]');
        if (!el) return;
        var group = GROUPS[name];
        var show = group.categories.indexOf(category) > -1 ||
          group.attributes.some(function (a) { return hasRefinement(state, a); });
        el.hidden = !show;
      });
    }

    return {
      widgets: buildWidgets,
      // Call once after search.start(): re-evaluates which spec groups to show after every render.
      attach: function (search) {
        search.on("render", function () { updateGroups(search); });
      },
      // Keep spec facets in the URL (?exhaust_system=Downpipe&hp_stock=100:200).
      toRoute: function (s, route) {
        LISTS.forEach(function (a) {
          if (s.refinementList && s.refinementList[a]) route[a] = s.refinementList[a];
        });
        rangeAttributes.forEach(function (a) {
          if (s.range && s.range[a]) route[a] = s.range[a];
        });
        return route;
      },
      fromRoute: function (route, state) {
        state.refinementList = state.refinementList || {};
        state.range = state.range || {};
        LISTS.forEach(function (a) {
          if (route[a]) state.refinementList[a] = [].concat(route[a]);
        });
        rangeAttributes.forEach(function (a) {
          if (route[a]) state.range[a] = route[a];
        });
        return state;
      },
    };
  };
})();
